import { Controller } from "@hotwired/stimulus"

// Protects email addresses from basic bots by reconstructing them via JavaScript
// Usage: <span data-controller="email-protection" data-email-protection-user-value="user" data-email-protection-domain-value="example.com"></span>

export default class extends Controller {
  static values = {
    user: String,
    domain: String,
    link: { type: Boolean, default: true }
  }

  connect() {
    const email = `${this.userValue}@${this.domainValue}`

    if (this.linkValue) {
      const link = document.createElement("a")
      link.href = `mailto:${email}`
      link.textContent = email
      link.className = "text-ppe hover:text-ppe-light underline"
      this.element.appendChild(link)
    } else {
      this.element.textContent = email
    }
  }
}
